
function DonationUpdateContent() {
    return (
        <div className="rs-event home8-style1 event-bg pt-100 pb-100 md-pt-70 md-pb-70">
            <div className="container">
                <div className="sec-title3 text-center">
                    {/* <div className="sub-title uppercase mb-10">
                        Latest Innovations
                    </div> */}
                    <h2 className="title mb-30">Notable Donations</h2>
                </div>
                {/* <div className="rs-carousel owl-carousel" data-loop="true" data-items="3" data-margin="30" data-autoplay="true" data-autoplay-timeout="7000" data-smart-speed="2000" data-dots="true" data-nav="false" data-nav-speed="false" data-mobile-device="1" data-mobile-device-nav="false"
                    data-mobile-device-dots="true" data-ipad-device="2" data-ipad-device-nav="false" data-ipad-device-dots="true" data-ipad-device2="1" data-ipad-device-nav2="false" data-ipad-device-dots2="true" data-md-device="3" data-md-device-nav="false"
                    data-md-device-dots="true">
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">Tarun Mehta & Swapnil Jain: Electrifying scooters</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">IITM students develop Intelligent Lighting Systems</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">Tarun Mehta & Swapnil Jain: Electrifying scooters</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">IITM students develop Intelligent Lighting Systems</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">IITM students develop Intelligent Lighting Systems</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">IITM students develop Intelligent Lighting Systems</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">Tarun Mehta & Swapnil Jain: Electrifying scooters</a></h4>
                            </div>
                        </div>
                    </div>
                    <div className="event-item">
                        <div className="event-short">
                            <div className="featured-img">
                                <img src="assets/images/event/2.jpg" alt="Image" />
                                <div className="dates">
                                    July 24, 2022
                                </div>
                            </div>
                            <div className="content-part">
                                <h4 className="title"><a href="#">IITM students develop Intelligent Lighting Systems</a></h4>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default DonationUpdateContent;